import React, { useEffect } from "react";
import { connect } from "react-redux";
import AllCoursesHome from "../../../../views/Library/AllCourses/AllCoursesHome";
import { makeGetEntities } from "../../../../redux/selectors/selectors";
import { useCourses } from "../../../../hooks/learningCenter/myLibrary/courses";
import { userAssignmentListTypes } from "../../../../constants";

const selector = makeGetEntities();

const queryTypes = [
  userAssignmentListTypes.recommended,
  userAssignmentListTypes.naaEligible,
  userAssignmentListTypes.latest
];

const requestIncludes = [
  "versions",
  "ilt_info",
  "ilt_info.instructor",
  "ilt_info.training_location"
];

const AllCoursesHomeContainer = ({
  latestReleases,
  recommendedCourses,
  assignedCourses,
  suggestedCourses,
  latestReleasesLoading,
  recommendedCoursesLoading
}) => {
  const { fetchCourses } = useCourses();
  useEffect(() => {
    queryTypes.forEach(type => {
      fetchCourses({
        params: { type },
        include: requestIncludes
      });
    });
  }, []);

  return (
    <div>
      <AllCoursesHome
        recommendedCourses={recommendedCourses}
        suggestedCourses={suggestedCourses}
        assignedCourses={assignedCourses}
        latestReleases={latestReleases}
        spinner={{
          recommendedCourses:
            (!recommendedCourses || recommendedCourses.length === 0) &&
            recommendedCoursesLoading,
          latestRelease:
            (!latestReleases || latestReleases.length === 0) &&
            latestReleasesLoading
        }}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  recommendedCourses: selector(state.userAssignmentsListState, {
    type: "version",
    id:
      state.userAssignmentsListState.displayedCourses[
        userAssignmentListTypes.recommended
      ]
  }),
  suggestedCourses: selector(state.userAssignmentsListState, {
    type: "version",
    id:
      state.userAssignmentsListState.displayedCourses[
        userAssignmentListTypes.naaEligible
      ]
  }),
  latestReleases: selector(state.userAssignmentsListState, {
    type: "version",
    id:
      state.userAssignmentsListState.displayedCourses[
        userAssignmentListTypes.latest
      ]
  }),
  recommendedCoursesLoading:
    state.userAssignmentsListState.loadingState[
      userAssignmentListTypes.recommended
    ],
  latestReleasesLoading:
    state.userAssignmentsListState.loadingState[userAssignmentListTypes.latest]
});

export default connect(mapStateToProps)(AllCoursesHomeContainer);
